import { render } from "./notification.vue?vue&type=template&id=0f3f1f4e&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import "./notification.vue?vue&type=style&index=0&id=0f3f1f4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3f1f4e"]])

export default __exports__